module.exports = __webpack_public_path__ + "img/2.a42f9fc1.jpg";